/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import Collapse from '@material-ui/core/Collapse';
import classNames from 'classnames';
import pages from '@/pages/configPages';

import s from './Drawer.module.css';

class DrawerWithChildrens extends React.Component {

    getLink({url, name}) {
        const className = classNames(
            s.link,
            {
                [s.linkActive]: this.props.pathname === url,
            },
        );

        return (
            <NavLink
                key={url}
                to={url}
                className={className}
            >
                <div className={s.linkContent}>
                        {name}
                </div>
            </NavLink>
        )
    }

    render() {
        const {name, url, childrens, open} = this.props;

        return (
            <>
                {this.getLink({name, url})}

                <Collapse in={open} className={s.collapse}>
                    <div className={open ? s.animation_start : s.animation_finish}>
                        {
                            childrens.map(({name, url}) => this.getLink({name, url}))
                        }
                    </div>
                </Collapse>
            </>
        );
    }
}

DrawerWithChildrens.propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    pathname: PropTypes.string.isRequired,
    childrens: PropTypes.any.isRequired,
};

class ResponsiveDrawer extends React.Component {

    render() {
        const {pathname} = this.props.location;

        return (
            <div className={s.wrapper}>
                {
                    pages.map(({name, url, childrens}) => {
                        if (childrens) {
                            return <DrawerWithChildrens
                                key={name}
                                name={name}
                                url={url}
                                childrens={childrens}
                                open={pathname.indexOf(url) !== -1}
                                pathname={pathname}
                            />
                        }

                        return (
                            <NavLink to={url} key={name} className={s.link} activeClassName={s.linkActive}>
                                <div className={s.linkContent}>
                                    {name}
                                </div>
                            </NavLink>);
                    })
                }
            </div>
        );
    }
}

export default withRouter(ResponsiveDrawer);
